import clsx from 'clsx'

function Office({
  name,
  children,
  invert = false,
}: {
  name: string
  children: React.ReactNode
  invert?: boolean
}) {
  return (
    <address
      className={clsx(
        'text-sm not-italic',
        invert ? 'text-zinc-300' : 'text-zinc-600',
      )}
      suppressHydrationWarning
    >
      <strong className={invert ? 'text-white' : 'text-zinc-950'}>
        {name}
      </strong>
      <br />
      {children}
    </address>
  )
}

export function Offices({
  invert = false,
  ...props
}: React.ComponentPropsWithoutRef<'ul'> & { invert?: boolean }) {
  return (
    <ul role="list" {...props}>
      <li>
        <Office name="Konstanz" invert={invert}>
          Bücklestraße 3
          <br />
          78467 Konstanz, Deutschland
          <br />
          <span suppressHydrationWarning>Tel.: +49 7531 / 1228920</span>
        </Office>
      </li>
    </ul>
  )
}
